<template>
	<div>
		<div class="content-header">
			<ol class="breadcrumb">
				<li>
					<router-link :to="{ name: 'memberList'}">
						会员列表
					</router-link>
				</li>
				<li class="active">会员详情</li>
			</ol>
		</div>
		<div class="content-from">
			<el-form ref="formName" :model="saveModel" :rules="rules" label-width="100px" style="width:80%;margin:0 auto;">
				<el-form-item label="头像:">
					<Upload :uploadData="uploadData" ref="headPortrait"></Upload>
				</el-form-item>
				<el-form-item label="昵称:" prop="nickname">
					<el-input v-model="saveModel.nickname" placeholder="请输入昵称"></el-input>
				</el-form-item>
				<el-form-item label="性别:" >
					<el-radio v-model="saveModel.gender" label="1">男</el-radio>
					<el-radio v-model="saveModel.gender" label="2">女</el-radio>
				</el-form-item>
				<el-form-item label="电话:" prop="telephone">
					<el-input v-model="saveModel.telephone" placeholder="请输入电话"></el-input>
				</el-form-item>
				<el-form-item label="状态:">
					<el-select clearable v-model="saveModel.status">
						<el-option v-for="item in status" :key="item.name" :label="item.label" :value="item.name"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="saveModel&&saveModel.level==='LEADER'" label="绑定经理:">
					<el-select clearable v-model="saveModel.managerUserId">
						<el-option v-for="item in managerMembers" :key="item.userId" :label="item.nickname" :value="item.userId"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<!--<el-button size="small" type="primary" @click="saveMember('formName')">确认</el-button>-->
					<el-button size="small" @click="$router.back(-1)">取消</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>
<script>
	import Upload from '@/components/upload.vue';
	export default {
		components: {
			Upload
		},
		data() {
			return {
				memberId: '',
				saveModel: {},
				uploadData: {
					folder: '',
					fileNamePre: 'member',
				},
				serverUrl: '',
				status: [],
				level:[],
				rules: {
					nackname: [{
						required: true,
						message: "请输入昵称",
						trigger: "blur"
					}],
				},
				managerMembers:[],
			}
		},
		mounted() {
			var _this = this;
			_this.serverUrl = config.hostUrl;
			_this.status = _this.$common.enum_config('EMemberStatus');
			_this.level = _this.$common.enum_config('EMemberLevel');
			_this.memberId = _this.$route.query.memberId;
			if (_this.memberId) {
				_this.detailMember();
				_this.findManagerMember();
			}
		},
		methods: {
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},
			//查询经理
			findManagerMember() {
				const _this = this;
				_this.managerMembers = [];
				_this.$common.my_ajax({
					url: 'member/pageMember',
					data: {
						limit: -1,
						level: 'MANAGER'
					},
					success: function (response) {
						_this.managerMembers = response.items;
					}
				});
			},
			detailMember() {
				var _this = this;
				_this.$common.my_ajax({
					url: 'member/detailMember',
					data: {
						memberId: _this.memberId
					},
					success: function(response) {
						_this.saveModel = response.item;
						_this.saveModel.gender=_this.saveModel.gender+'';
						_this.$refs.headPortrait.loadIconPath(response.item.iconPath);
					}
				});
			},
			saveMember(formName) {
				var _this = this;
				_this.$refs[formName].validate((valid) => {
					if (valid) {
						_this.saveModel.iconPath = _this.$refs.headPortrait.getIconPath();
						if (_this.saveMemberCheck()) {
							_this.$common.my_ajax({
								url: 'member/saveMember',
								data: _this.saveModel,
								success: function(response) {
									_this.$message({
										message: '保存成功',
										type: 'success',
										duration: 1000,
										onClose: function() {
											_this.$router.back(-1);
										}
									});
								}
							});
						}
					} else {
						return false;
					}
				});
			},
			saveMemberCheck() {
				var _this = this;
				if (!_this.saveModel.iconPath) {
					_this.$message({
						showClose: true,
						message: '请上传头像',
						duration: 1000,
						type: 'error',
					});
					return false;
				}
				if (!_this.saveModel.level) {
					_this.$message({
						showClose: true,
						message: '请选择等级',
						duration: 1000,
						type: 'error',
					});
					return false;
				}
				if (!_this.saveModel.status) {
					_this.$message({
						showClose: true,
						message: '请选择状态',
						duration: 1000,
						type: 'error',
					});
					return false;
				}
				return true;
			},
		},
	}
</script>

<style scoped>
	.col-sm-3 {
		width: 20%;
	}

	.property-box {
		width: auto !important;
		max-width: 678px;
	}

	.can-shu {
		width: 160px;
		margin-bottom: 20px;
	}
</style>
